enum ActionTypes {
  TRACK = "acko/bike_track",
  TRACK_SUCCESS = "acko/bike_track_success",
  GTM = "acko/bike_GTM"
}

export default ActionTypes;
